<template>
  <div class="move-navigation">
    <button-tooltip
      tooltip="Go to start"
      icon-left="fast-backward"
      size="is-small"
      class="nav-button"
      @click="$emit('goToStart')"
      :disabled="isAtStart"
    />

    <button-tooltip
      tooltip="Previous move"
      icon-left="arrow-left"
      size="is-small"
      class="nav-button"
      @click="$emit('previousMove')"
      :disabled="isAtStart"
    />

    <button-tooltip
      tooltip="Next move"
      icon-left="arrow-right"
      size="is-small"
      class="nav-button"
      @click="$emit('nextMove')"
      :disabled="isAtEnd"
    />

    <button-tooltip
      tooltip="Go to end"
      icon-left="fast-forward"
      size="is-small"
      class="nav-button"
      @click="$emit('goToEnd')"
      :disabled="isAtEnd"
    />

    <button-tooltip
      :tooltip="showVariations ? 'Hide variations' : 'Show variations'"
      :type="showVariations ? 'is-success is-light' : 'is-light'"
      :icon-left="showVariations ? 'code-branch' : 'code-branch'"
      size="is-small"
      class="nav-button"
      @click="$emit('toggleVariations')"
    />
  </div>
</template>

<script>
import ButtonTooltip from "@/components/ui/ButtonTooltip.vue";

export default {
  name: "MoveNavigation",
  components: { ButtonTooltip },

  props: {
    isAtStart: { type: Boolean, default: true },
    isAtEnd: { type: Boolean, default: false },
    showVariations: { type: Boolean, required: true },
  },

  emits: [
    "previousMove",
    "nextMove",
    "goToStart",
    "goToEnd",
    "toggleVariations",
  ],

  methods: {
    handleKeyboardEvent(event) {
      // Check if any modal is open and visible
      const activeModal = document.querySelector(".modal.is-active");
      if (
        activeModal &&
        window.getComputedStyle(activeModal).display !== "none"
      ) {
        return;
      }

      // Check if user is typing in an input field
      if (
        event.target.tagName === "INPUT" ||
        event.target.tagName === "TEXTAREA"
      ) {
        return;
      }

      if (event.key === "ArrowLeft") {
        event.preventDefault();
        if (event.shiftKey && !this.isAtStart) {
          this.$emit("goToStart");
        } else if (!this.isAtStart) {
          this.$emit("previousMove");
        }
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        if (event.shiftKey && !this.isAtEnd) {
          this.$emit("goToEnd");
        } else if (!this.isAtEnd) {
          this.$emit("nextMove");
        }
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        this.$emit("previousVariation");
      } else if (event.key === "ArrowDown") {
        event.preventDefault();
        this.$emit("nextVariation");
      }
    },
  },

  mounted() {
    window.addEventListener("keydown", this.handleKeyboardEvent);
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyboardEvent);
  },
};
</script>

<style scoped>
.move-navigation {
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
  justify-content: space-between;
  align-items: center;
}

.nav-button::v-deep .button {
  min-width: 2.5rem;
}
</style>
